/*
  DENIMFY 13.10.2026 – Größen-Dropdown für Jeans mit getrennten Optionen „Länge“ und „Weite“
  Gehört zu snippets/df-jeans-groesse.liquid.
  - Auswahl im Dropdown „Größe“ stellt die beiden unsichtbaren Felder Länge und Weite ein
    und hinterlegt die richtige Variante. Danach läuft alles wie gewohnt über product.js
    (Preis, Bilder, Warenkorb, „Benachrichtige mich“).
  - Nach jeder Änderung (z. B. Farbwechsel) zeigt das Dropdown nur die Größen der gewählten Farbe.
  - Farbwechsel: Gibt es die gewählte Größe in der neuen Farbe nicht (oder ist sie ausverkauft),
    wird möglichst dieselbe Weite mit der nächstliegenden Länge gewählt.
*/
(function () {
  if (customElements.get('df-jeans-groesse')) return;

  function zahl(wert) {
    var n = parseFloat(String(wert).replace(',', '.').replace(/[^0-9.]/g, ''));
    return isNaN(n) ? 0 : n;
  }

  // Wert eines Feldes lesen (Dropdown oder Auswahlknöpfe)
  function feldWert(fieldset) {
    var select = fieldset.querySelector('select');
    if (select) return select.value;
    var checked = fieldset.querySelector('input:checked');
    return checked ? checked.value : null;
  }

  // Eintrag mit diesem Wert in einem Feld finden (Dropdown oder Auswahlknöpfe)
  function feldEintrag(fieldset, wert) {
    var eintraege = fieldset.querySelector('select') ? fieldset.querySelectorAll('select option') : fieldset.querySelectorAll('input[type="radio"]');
    return Array.prototype.find.call(eintraege, function (eintrag) { return eintrag.value === wert; }) || null;
  }

  // Wert in ein Feld schreiben (Dropdown oder Auswahlknöpfe)
  function feldSetzen(fieldset, wert) {
    var select = fieldset.querySelector('select');
    if (select) {
      select.value = wert;
      return;
    }
    var eintrag = feldEintrag(fieldset, wert);
    if (eintrag) eintrag.checked = true;
  }

  class DfJeansGroesse extends HTMLElement {
    connectedCallback() {
      if (this._dfStart) return;
      this._dfStart = true;
      this.picker = this.closest('variant-selects');
      if (!this.picker) return;
      this.lIndex = parseInt(this.dataset.laengeIndex, 10) - 1;
      this.wIndex = parseInt(this.dataset.weiteIndex, 10) - 1;

      this.sortieren();
      this.addEventListener('click', this.onClick.bind(this));
      this.addEventListener('keydown', this.onKey.bind(this));
      // Farbwechsel: läuft nach df-farbwechsel-groesse.js und vor product.js
      this.picker.addEventListener('change', this.onFarbwechsel.bind(this), true);
      // Nach jeder Änderung die Anzeige abgleichen
      this.picker.addEventListener('change', () => setTimeout(() => this.sync(), 0));
      this._onVariantChange = () => this.sync();
      document.addEventListener('product:variant-change', this._onVariantChange);
      this.sync();
    }

    disconnectedCallback() {
      if (this._onVariantChange) document.removeEventListener('product:variant-change', this._onVariantChange);
    }

    // Größen nach Weite, dann Länge sortieren (unabhängig von der Reihenfolge im Admin)
    sortieren() {
      var panel = this.querySelector('.custom-select__panel');
      if (!panel) return;
      var liste = this.optionen();
      var sortiert = liste.slice().sort(function (a, b) {
        var dw = zahl(a.dataset.weite) - zahl(b.dataset.weite);
        if (dw !== 0) return dw;
        return zahl(a.dataset.laenge) - zahl(b.dataset.laenge);
      });
      var gleich = sortiert.every(function (opt, i) { return opt === liste[i]; });
      if (!gleich) sortiert.forEach(function (opt) { panel.appendChild(opt); });
    }

    fieldsets() {
      return Array.prototype.slice.call(this.picker.querySelectorAll('fieldset'));
    }

    werte(fieldsets) {
      return fieldsets.map(feldWert);
    }

    restSchluessel(werte) {
      var rest = '';
      for (var i = 0; i < werte.length; i++) {
        if (i === this.lIndex || i === this.wIndex) continue;
        rest += (werte[i] === null ? '' : werte[i]) + '||';
      }
      return rest;
    }

    optionen() {
      return Array.prototype.slice.call(this.querySelectorAll('.df-jg__option'));
    }

    sync() {
      var fieldsets = this.fieldsets();
      if (!fieldsets[this.lIndex] || !fieldsets[this.wIndex]) return;
      var werte = this.werte(fieldsets);
      var rest = this.restSchluessel(werte);
      var laenge = werte[this.lIndex];
      var weite = werte[this.wIndex];
      var gewaehlt = null;

      this.optionen().forEach(function (opt) {
        var sichtbar = opt.dataset.rest === rest;
        opt.hidden = !sichtbar;
        var istGewaehlt = sichtbar && opt.dataset.laenge === laenge && opt.dataset.weite === weite;
        opt.setAttribute('aria-selected', istGewaehlt ? 'true' : 'false');
        if (istGewaehlt) gewaehlt = opt;
      });

      var anzeige = this.querySelector('.custom-select__value');
      if (anzeige) {
        var label = gewaehlt ? gewaehlt.querySelector('.custom-select__option-label') : null;
        anzeige.textContent = label ? label.textContent.trim() : 'Größe wählen';
      }
      this.letzteLaenge = laenge;
      this.letzteWeite = weite;
    }

    // Länge und Weite der gewählten Größe in die unsichtbaren Felder schreiben
    uebernehmen(opt, fieldsets) {
      var feldL = fieldsets[this.lIndex];
      var feldW = fieldsets[this.wIndex];
      if (!feldL || !feldW) return false;
      // Erst prüfen, ob es beide Werte gibt – sonst nichts ändern
      if (!feldEintrag(feldL, opt.dataset.laenge) || !feldEintrag(feldW, opt.dataset.weite)) return false;
      feldSetzen(feldL, opt.dataset.laenge);
      feldSetzen(feldW, opt.dataset.weite);
      // product.js nimmt die Variante vom zuletzt gewählten Feld – dort die richtige ID hinterlegen
      var letztes = fieldsets[fieldsets.length - 1];
      var gewaehltesFeld = letztes.querySelector('select option:checked') || letztes.querySelector('input:checked');
      if (gewaehltesFeld) gewaehltesFeld.setAttribute('variant_id', opt.dataset.variantId);
      return true;
    }

    schliessen() {
      var panel = this.querySelector('.custom-select__panel');
      var trigger = this.querySelector('.custom-select__trigger');
      if (panel) panel.classList.remove('is-open');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
    }

    waehlen(opt) {
      var fieldsets = this.fieldsets();
      if (!this.uebernehmen(opt, fieldsets)) return;
      this.schliessen();
      this.sync();
      this.picker.dispatchEvent(new Event('change'));
    }

    onClick(e) {
      var opt = e.target.closest('.df-jg__option');
      if (!opt || opt.hidden) return;
      // Auch beim Klick auf „Benachrichtige mich“ zuerst die Größe wählen;
      // product.js öffnet danach das Benachrichtigungs-Fenster für genau diese Variante.
      this.waehlen(opt);
    }

    onKey(e) {
      if (e.key === 'Escape') {
        this.schliessen();
        var trigger = this.querySelector('.custom-select__trigger');
        if (trigger && this.contains(document.activeElement)) trigger.focus();
        return;
      }
      if (e.key !== 'Enter' && e.key !== ' ') return;
      if (e.target.closest('.custom-select__notify-btn')) return;
      var opt = e.target.closest('.df-jg__option');
      if (!opt) return;
      e.preventDefault();
      this.waehlen(opt);
    }

    onFarbwechsel(e) {
      var input = e.target;
      if (!input || input.tagName !== 'INPUT' || input.type !== 'radio') return;
      if (this.letzteWeite == null) return;
      var fieldsets = this.fieldsets();
      var index = fieldsets.indexOf(input.closest('fieldset'));
      if (index < 0 || index === this.lIndex || index === this.wIndex) return;

      var rest = this.restSchluessel(this.werte(fieldsets));
      var kandidaten = this.optionen().filter(function (o) { return o.dataset.rest === rest; });
      if (!kandidaten.length) return;

      var w0 = this.letzteWeite, l0 = this.letzteLaenge;
      var exakt = kandidaten.find(function (o) { return o.dataset.weite === w0 && o.dataset.laenge === l0; });
      var reihenfolge = function (a, b) {
        var wa = a.dataset.weite === w0 ? 0 : 1, wb = b.dataset.weite === w0 ? 0 : 1;
        if (wa !== wb) return wa - wb;
        var dw = Math.abs(zahl(a.dataset.weite) - zahl(w0)) - Math.abs(zahl(b.dataset.weite) - zahl(w0));
        if (dw !== 0) return dw;
        return Math.abs(zahl(a.dataset.laenge) - zahl(l0)) - Math.abs(zahl(b.dataset.laenge) - zahl(l0));
      };

      var ziel;
      if (exakt && exakt.dataset.available === 'true') {
        ziel = exakt;
      } else {
        var lieferbar = kandidaten.filter(function (o) { return o.dataset.available === 'true'; });
        if (lieferbar.length) {
          ziel = lieferbar.slice().sort(reihenfolge)[0];
        } else if (exakt) {
          ziel = exakt;
        } else {
          ziel = kandidaten.slice().sort(reihenfolge)[0];
        }
      }
      if (ziel) this.uebernehmen(ziel, fieldsets);
    }
  }

  customElements.define('df-jeans-groesse', DfJeansGroesse);
})();
